var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"animation",staticClass:"animation"},[_c('div',{staticClass:"lattice"},[_c('div',{ref:"timbers",staticClass:"timber timber_hor-1"}),_c('div',{staticClass:"timber timber_vert-1"})])])}
var staticRenderFns = []

export { render, staticRenderFns }